import { gracenoteApiCall } from './../../api/api';
import { GET_MUNDIAL_TEAMS } from './../types/teams.types';

export const getMundialTeams = () => async dispatch => {
  try {
    const { data } = await gracenoteApiCall({
      url: '/leagues/GNA5MGHG2ZVX2RD/teams',
    });

    dispatch({
      type: GET_MUNDIAL_TEAMS,
      payload: data.teams,
    });
  } catch (error) {}
};
